import axios from "axios";
import { endpoint } from "./endpoint";

async function createRequest({ headers, params, authToken,  responseType="json" , jsonData }) {
  const isFormData = jsonData instanceof FormData;
  const config = authToken
    ? {
        "Content-Type": isFormData ? undefined : headers?.["Content-Type"] || "application/json",
        "x-correlation-id": "LOS-" + sessionStorage.getItem("session") + "-" + new Date().getTime(),
        "session-id": sessionStorage.getItem('session'),
        Accept: "application/json",
        Authorization: "Bearer " + authToken,
        ...headers,
      }
    : {
        "Content-Type": headers?.["Content-Type"] || "application/json",
        "x-correlation-id": "LOS-" + sessionStorage.getItem("session") + "-" + new Date().getTime(),
        "session-id": sessionStorage.getItem('session'),
        Accept: "application/json",
        ...headers,
      };
  return axios.create({
    responseType:responseType,
    baseURL: endpoint.BASE_URL_STAGING,
    crossdomain: true,
    headers: config,
    params,
  });
}

export const handleCatchBlock = () => {
  console.log("Something went wrong fetching apis");
};

export async function apiHandler({
  url,
  method,
  headers: reqHeaders,
  data: jsonData,
  params,
  authToken,
  responseType,
}) {
  try {
    const request = await createRequest({ reqHeaders, params, authToken, responseType , jsonData});
    let result = [];
    switch (method) {
      case "POST":
        result = await request.post(url, jsonData);
        break;

      case "DELETE":
        result = await request.delete(url);
        break;
      case "PUT":
        result = await request.put(url, jsonData);
        break;

      default:
        result = await request.get(url);
    }
    const { data, headers, status } = result;
    return { data, headers, status };
  } catch (error) {
    handleCatchBlock();
    const { data, headers, status } = error.response;
    return { data, headers , status};
  }
}
